export const DRIVERS_LOAD_REQUEST = 'DRIVERS_LOAD_REQUEST';
export const DRIVERS_LOAD_SUCCESS = 'DRIVERS_LOAD_SUCCESS';
export const DRIVERS_LOAD_FAILURE = 'DRIVERS_LOAD_FAILURE';
// Background revalidation: doesn't flip `loading`, so the skeleton doesn't flash
// while we silently refresh a cached list.
export const DRIVERS_REVALIDATE_REQUEST = 'DRIVERS_REVALIDATE_REQUEST';
// Patch a single driver into the cached list (by id) — used by mutations and
// by the detail-page fetch so the list row stays in sync without a full refetch.
export const DRIVERS_UPSERT_ONE = 'DRIVERS_UPSERT_ONE';
